import React from 'react';
var SnippylyHuddle = function (props) {
    var chat = props.chat, flockModeOnAvatarClick = props.flockModeOnAvatarClick, serverFallback = props.serverFallback;
    return (React.createElement("velt-huddle", { chat: [true, false].includes(chat) ? (chat ? 'true' : 'false') : undefined, "flock-mode-on-avatar-click": [true, false].includes(flockModeOnAvatarClick) ? (flockModeOnAvatarClick ? 'true' : 'false') : undefined, "server-fallback": [true, false].includes(serverFallback) ? (serverFallback ? 'true' : 'false') : undefined }));
};
export default SnippylyHuddle;
